import { Component, OnInit } from '@angular/core';
import { FlowServiceService } from '../../Services/flow-service.service';

@Component({
  selector: 'app-community-guidelines',
  templateUrl: './community-guidelines.component.html',
  styleUrls: ['./community-guidelines.component.scss']
})
export class CommunityGuidelinesComponent implements OnInit {
  sections = [
    { id: 'principle', title: 'Our Principle' },
    { id: 'encouraged', title: 'What\'s Encouraged' },
    { id: 'not-allowed', title: 'What\'s Not Allowed' },
    { id: 'safety', title: 'Safety First' },
    { id: 'enforcement', title: 'Enforcement' },
    { id: 'final-note', title: 'Final Note' }
  ];

  constructor(private flowServiceService: FlowServiceService) { 
    window.scrollTo(0,0);
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    window.scrollTo(0,0)
    this.flowServiceService.setScrollTop();
  }
}





